import Link from 'next/link';
import { AmazonRedImage } from '../../svgImages/AmazonRedImage';
import { HelpRedImage } from '../../svgImages/HelpRedImage';

export const ButtonLinkSecondary: React.FC<
  React.AnchorHTMLAttributes<HTMLAnchorElement> & {
    href: string;
    text: string;
    icon?: 'amazon' | 'help';
  }
> = ({ href = '', text, icon = null, ...attr }) => (
  <Link href={href} legacyBehavior>
    <a
      {...attr}
      className="tw-group tw-relative tw-flex tw-min-h-[3rem] tw-w-full tw-justify-center tw-rounded-[0.2rem] tw-px-[1rem] tw-py-[0.5rem]"
    >
      <div className="tw-absolute tw-inset-0 tw-rounded-[0.2rem] tw-border-[2px] tw-border-brand-lv1" />
      <div className="tw-relative tw-grid tw-w-fit tw-grid-cols-[auto,1fr] tw-items-center tw-gap-[0.25rem]">
        {icon === 'amazon' && (
          <div>
            <AmazonRedImage
              alt={text}
              className="tw-h-[1.5rem] tw-w-[1.5rem] tw-object-contain"
            />
          </div>
        )}
        {icon === 'help' && (
          <div>
            <HelpRedImage
              alt={text}
              className="tw-h-[1.5rem] tw-w-[1.5rem] tw-object-contain"
            />
          </div>
        )}
        <div className="tw-text-button tw-text-brand-lv1 tw-transition-colors group-hover:tw-text-main-100">
          {text}
        </div>
      </div>
    </a>
  </Link>
);
